import React from 'react';

export function ErrorIcon(props:React.SVGProps<SVGSVGElement>){
    return (
        <svg viewBox="0 0 64 64" {...props}>
        <path className="st2" d="M46.9,40.8c0-0.7-0.2-1.3-0.7-1.8L39.1,32l7.1-7.1c0.5-0.5,0.7-1.1,0.7-1.8c0-0.7-0.2-1.3-0.7-1.8l-3.5-3.5
            c-0.5-0.5-1.1-0.7-1.8-0.7c-0.7,0-1.3,0.2-1.8,0.7L32,24.9l-7.1-7.1c-0.5-0.5-1.1-0.7-1.8-0.7c-0.7,0-1.3,0.2-1.8,0.7l-3.5,3.5
            c-0.5,0.5-0.7,1.1-0.7,1.8c0,0.7,0.2,1.3,0.7,1.8l7.1,7.1l-7.1,7.1c-0.5,0.5-0.7,1.1-0.7,1.8c0,0.7,0.2,1.3,0.7,1.8l3.5,3.5
            c0.5,0.5,1.1,0.7,1.8,0.7c0.7,0,1.3-0.2,1.8-0.7l7.1-7.1l7.1,7.1c0.5,0.5,1.1,0.7,1.8,0.7c0.7,0,1.3-0.2,1.8-0.7l3.5-3.5
            C46.6,42.1,46.9,41.5,46.9,40.8z M62,32c0,5.4-1.3,10.5-4,15.1S51.7,55.3,47.1,58s-9.6,4-15.1,4s-10.5-1.3-15.1-4S8.7,51.7,6,47.1
            S2,37.4,2,32s1.3-10.5,4-15.1S12.3,8.7,16.9,6S26.6,2,32,2s10.5,1.3,15.1,4s8.2,6.3,10.9,10.9S62,26.6,62,32z"/>
        </svg>

    )
}